const TAPE = [
  "AU MARKET A$234.5B",
  "FORECAST ~A$300B BY 2029 (EY-PARTHENON)",
  "TOP 10 MANAGERS HOLD 38.3%",
  "ASIC REP 814 COMPLIANCE BENCHMARK",
];

export const Ticker = () => (
  <div className="border-b border-line bg-navy-alt py-3 overflow-hidden font-mono" data-testid="market-ticker">
    <div className="mq-banner flex items-center gap-12 text-xs text-cy">
      {[...TAPE, ...TAPE].map((item, i) => (
        <span key={i} className="flex items-center gap-12">
          <span>{item}</span>
          <span className="text-slate-600">|</span>
        </span>
      ))}
    </div>
  </div>
);
